export default {
  analytics: "Аналитика",
  "legal-entity": "Юридикалык жактар",
  "trading-point": "Соода чекиттери",
  employee: "Кассирлер",
  document: "Документтер",
  tariff: "Тарифтер",
  operation: "Операциялар тарыхы",
  "act-and-receipt": "Акттар жана эсеп-фактуралар",
  manager: "Менеджерлер",
  cashback: "Баллдарды эсептөө",
  balance: "Баланс",
  points: "Кассирлердин упайлары",
  client: "Кардарлар тизмеси",
  spread: "RC карталарын жайылтуу",
  "wallet-pass": "Wallet картасынын дизайны",
  review: "Пикирлер",
  "noncash-tips": "Накталай эмес чайпулдар",
  "check-counterparties": "Контрагенттерди текшерүү",
  "push-notifications": "Wallet Push-билдирмелери",
  "client-portrait": "Кардардын портрети",
  "active-wait": "Баллдарды эсептөө (Активдүү күтүү)",
  "e-menu": "Онлайн каталог",
  "telegram-notification": "Telegram билдирмелери",
  faq: "FAQ",
  terminal: "Процессинг",
  promotion: "Акциялар",
  cashback_group: "Баллдарды эсептөө (Кардарлар топтору)",
  payment_info: "Төлөм ыкмалары",
  orders: "Заказдар / RC PAY менюсу",
  "trading-point-promotion": "Алга жылдыруу",
  "gift-card": "Белек карталары",
  "kassa-orders": "Заказдар / RC KASSA каталогу",
  "partner-profile": "Өнөктөштүн профили",
};
